var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5047 2.37209H12.1662C13.4425 2.37209 14.4771 3.40674 14.4771 4.68305V8.43838C14.4771 8.75746 14.2185 9.01612 13.8994 9.01612C13.5803 9.01612 13.3216 8.75746 13.3216 8.43838V4.68305C13.3216 4.04491 12.8043 3.52757 12.1662 3.52757H11.5047C11.2561 4.36284 10.4823 4.97193 9.56632 4.97193H5.52213C4.60612 4.97193 3.83235 4.36284 3.58378 3.52757H2.92229C2.28415 3.52757 1.76681 4.04491 1.76681 4.68305V15.949C1.76681 16.5872 2.28415 17.1045 2.92229 17.1045H5.23326C5.55235 17.1045 5.811 17.3632 5.811 17.6822C5.811 18.0013 5.55235 18.26 5.23326 18.26H2.92229C1.64598 18.26 0.611328 17.2253 0.611328 15.949V4.68305C0.611328 3.40674 1.64598 2.37209 2.92229 2.37209H3.58378C3.83235 1.53682 4.60612 0.927734 5.52213 0.927734H9.56632C10.4823 0.927734 11.2561 1.53682 11.5047 2.37209ZM4.65552 2.94983C4.65552 2.47121 5.0435 2.08322 5.52213 2.08322H9.56632C10.045 2.08322 10.4329 2.47121 10.4329 2.94983C10.4329 3.42846 10.045 3.81644 9.56632 3.81644H5.52213C5.0435 3.81644 4.65552 3.42846 4.65552 2.94983Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05061 10.1709C7.75938 10.1709 6.67773 11.1866 6.67773 12.4819V15.9483C6.67773 17.2436 7.75938 18.2593 9.05061 18.2593H13.8376C15.1288 18.2593 16.2105 17.2436 16.2105 15.9483V12.4819C16.2105 11.1866 15.1288 10.1709 13.8376 10.1709H9.05061ZM10.5259 11.3264H12.3623V12.4819H10.5259V11.3264ZM9.37041 13.0596V11.3264H9.05061C8.35899 11.3264 7.83322 11.8626 7.83322 12.4819V15.9483C7.83322 16.5675 8.35899 17.1038 9.05061 17.1038H13.8376C14.5292 17.1038 15.055 16.5675 15.055 15.9483V12.4819C15.055 11.8626 14.5292 11.3264 13.8376 11.3264H13.5178V13.0596C13.5178 13.3787 13.2591 13.6373 12.94 13.6373H9.94816C9.6291 13.6373 9.37041 13.3787 9.37041 13.0596Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryOrderIcon);
export default __webpack_public_path__ + "static/media/inventory-order-icon.60418cd7b954715802b7dc3d830110cf.svg";
export { ForwardRef as ReactComponent };